import { stripInvisibles } from '@workspace/constants';
// Grid layout helper
export const getGridColumns = (layout: number | undefined) => {
  switch (layout) {
    case 1:
      return 'grid-cols-1';
    case 2:
      return 'grid-cols-1 md:grid-cols-2';
    case 3:
      return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
    case 4:
      return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
    default:
      return 'grid-cols-1';
  }
};

// Text alignment helper
export const getMultiColumnBannerAlignmentClass = (alignment: string | undefined) => {
  const normalized = stripInvisibles(alignment || '')
    .trim()
    .toLowerCase();
  switch (normalized) {
    case 'left':
      return 'text-left';
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
    default:
      return 'text-center';
  }
};
